import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { isDropWellCompare } from 'utils/Global';

import './ScoresPanel.scss';
import { useRMSelector } from 'redux/hooks';
import ScoringTools from './ScoringTools/ScoringTools';
import MarcoScore from './MarcoScore/MarcoScore';
import DefaultScores from './DefaultScores/DefaultScores';
import { IStyle } from 'Styles';
import RMTabs from 'components/customComponents/Controls/RMTabs';
import { ITabItem } from 'components/tab';
import {
  selectScoresOptionsList,
  selectExp,
} from '../../../redux/selectors/ExperimentStateSelector';
import { DisputedScoresIds } from 'business/models/Models';
import { markDisputedScores } from 'redux/reducers/experimentDataReducer';
import {
  useScoresForWells,
  useAllWellNavigationDetails,
  useSelectedDropImageParameters,
} from 'redux/hooks/experiment';
import { useApplyScoring } from 'components/Experiment/hooks';

function ScoresPanel() {
  const dispatch = useDispatch();
  const isDropWellCompareMode = isDropWellCompare();
  const expData = useRMSelector(selectExp);

  const scoresOptionsList = useRMSelector(selectScoresOptionsList);
  const allWellNavigationDetails = useAllWellNavigationDetails();

  const selectedDropImageParameters = useSelectedDropImageParameters();
  const lastSelectedWell =
    allWellNavigationDetails?.[allWellNavigationDetails?.length - 1];
  const { inspection, dropNumber, cpId } = selectedDropImageParameters || {};

  const selectedWellDetails = isDropWellCompareMode
    ? [allWellNavigationDetails[allWellNavigationDetails.length - 1]]
    : allWellNavigationDetails;
  const imageBatchId = inspection?.groupedInspections?.find(
    (grp) => grp.plateId === selectedWellDetails?.[0]?.plateID,
  )?.imageBatchId;
  const scoresOfSelectedWells = useScoresForWells(
    selectedWellDetails.map((w) => ({
      wellNumber: w.wellNum,
      plateId: w.plateID,
      dropNumber: dropNumber,
    })),
  );
  const applyScoring = useApplyScoring();

  const handleOnMarkDisputedScore = (disputedScoresIds: DisputedScoresIds[]) => {
    dispatch(
      markDisputedScores({
        plateId: lastSelectedWell?.plateID,
        wellNumber: lastSelectedWell.wellNum,
        disputedScoreGroupsIds: disputedScoresIds,
      }),
    );
  };

  const tabComponents: ITabItem[] = useMemo(
    () => [
      {
        title: 'Filter',
        eventKey: 'filter',
        content: (
          <ScoringTools
            scoresOptionsList={scoresOptionsList}
            selectedWellsScores={scoresOfSelectedWells}
            expData={expData}
            wellDetails={selectedWellDetails?.[selectedWellDetails?.length - 1]}
            applyScoring={applyScoring}
            imageBatchId={imageBatchId}
            dropNumber={dropNumber}
          />
        ),
      },
      {
        title: 'Scores',
        eventKey: 'scoreGroup',
        content: (
          <DefaultScores
            selectedWellDetails={selectedWellDetails}
            selectedWellsScores={scoresOfSelectedWells}
            applyScoring={applyScoring}
            imageBatchId={imageBatchId}
            dropNumber={dropNumber}
            cpId={cpId}
          />
        ),
      },
      {
        title: 'Auto Score',
        eventKey: 'autoScore',
        content: (
          <MarcoScore
            handleOnMarkDisputedScore={handleOnMarkDisputedScore}
            imageBatchId={imageBatchId}
            dropNumber={dropNumber}
          />
        ),
      },
    ],
    [scoresOfSelectedWells],
  );

  return (
    <div id='exppanel-scorespanel-wrappeer' className="container-fluid p-0 border" style={styles.container}>
      <div id='exppanel-scorespanel-row' className="row">
        <div id='exppanel-scorespanel-col' className="col-md-12">
          <RMTabs id={'exppanel-scorespanel-scoretab'} tabItems={tabComponents} defaultActiveKey={'filter'}  />
        </div>
      </div>
    </div>
  );
}
//if we don't use memo, the component remount repeatedly
export default React.memo(ScoresPanel);

const styles: IStyle = {
  container: {
    height: '800px',
  },
};
